import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <section id="contact" className="contact section">
      <div className="container">
        <div className="contact-header">
          <h2>Wir freuen uns über Ihr Interesse an unserem Angebot und sind gerne für Sie da. Schreiben Sie uns!</h2>
          <div className="contact-methods">
            <div className="contact-method">
              <i className="fas fa-phone"></i>
              <span>0172 544 3697</span>
            </div>
            <div className="contact-method">
              <i className="fas fa-envelope"></i>
              <span>info@dienstleistungensk.de</span>
            </div>
            <div className="contact-method">
              <i className="fas fa-map-marker-alt"></i>
              <span>Lindau, Deutschland</span>
            </div>
          </div>
        </div>

        {/* Photo Section */}
        <div className="contact-photo-section">
          <div className="photo-container">
            <img src="/kerri.jpeg" alt="SK Dienstleistungen Team" className="contact-photo" />
            <div className="photo-overlay">
              <div className="photo-content">
                <h4>Professionelle Dienstleistungen</h4>
                <p>Erfahrene Fachkräfte für Ihre Immobilie</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
